import { WidgetNoteFontSize } from "./__generated__/useNoteWidgetStyleText_widgetNotePage.graphql";

export const widgetNoteFontSize = (fontSize: WidgetNoteFontSize) => {
  switch (fontSize) {
    case "SMALL":
      return 16;
    case "MEDIUM":
      return 24;
    case "LARGE":
      return 39;
    default:
      return 16;
  }
};
